import { c as _c } from "react/compiler-runtime";
import React, { ChangeEvent, ReactElement, useCallback, useEffect, useRef, useState } from 'react';
import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import styles from './multiRangeSlider.component.module.scss';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
enum SelectorType {
  MIN,
  MAX,
}
interface Props {
  readonly min: number;
  readonly max: number;
  readonly selectedMin: number;
  readonly selectedMax: number;
  readonly value: string;
  readonly onChange: (code: string, min: number, max: number) => void;
  readonly label: string;
  readonly quantitySymbol: string;
}
function MultiRangeSliderComponent(t0) {
  const $ = _c(129);
  const {
    min,
    max,
    selectedMin,
    selectedMax,
    onChange,
    value,
    label,
    quantitySymbol
  } = t0;
  const {
    formatMessage,
    keyExists
  } = useNamespacedIntl("facet");
  let t1;
  if ($[0] !== selectedMax || $[1] !== selectedMin) {
    t1 = {
      min: selectedMin,
      max: selectedMax
    };
    $[0] = selectedMax;
    $[1] = selectedMin;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const [inputValues, setInputValues] = useState(t1);
  let t2;
  if ($[3] !== selectedMax || $[4] !== selectedMin) {
    t2 = {
      min: selectedMin,
      max: selectedMax
    };
    $[3] = selectedMax;
    $[4] = selectedMin;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const [rangeValues, setRangeValues] = useState(t2);
  const range = useRef(null);
  let t3;
  if ($[6] !== max || $[7] !== min) {
    t3 = value_0 => Math.round((value_0 - min) / (max - min) * 100);
    $[6] = max;
    $[7] = min;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const getPercent = t3;
  let t4;
  if ($[9] !== getPercent || $[10] !== rangeValues.max || $[11] !== rangeValues.min) {
    t4 = () => {
      const minPercent = getPercent(rangeValues.min);
      const maxPercent = getPercent(rangeValues.max);
      if (range.current) {
        range.current.style.left = `${minPercent}%`;
        range.current.style.width = `${maxPercent - minPercent}%`;
      }
    };
    $[9] = getPercent;
    $[10] = rangeValues.max;
    $[11] = rangeValues.min;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== getPercent || $[14] !== rangeValues) {
    t5 = [getPercent, rangeValues];
    $[13] = getPercent;
    $[14] = rangeValues;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  useEffect(t4, t5);
  let t6;
  if ($[16] !== max || $[17] !== min) {
    t6 = (e, selectorType) => {
      const value_1 = e.target.value.replace(/\D/g, "");
      const parsedValue = value_1 ? parseInt(value_1, 10) : undefined;
      const isValidValue = value_2 => value_2 >= min && value_2 <= max;
      if (selectorType === SelectorType.MIN) {
        setInputValues(prev => ({
          ...prev,
          min: parsedValue
        }));
        if (parsedValue !== undefined && isValidValue(parsedValue)) {
          setRangeValues(prevValues => ({
            ...prevValues,
            min: parsedValue
          }));
        }
      } else {
        setInputValues(prev_0 => ({
          ...prev_0,
          max: parsedValue
        }));
        if (parsedValue !== undefined && isValidValue(parsedValue)) {
          setRangeValues(prevValues_0 => ({
            ...prevValues_0,
            max: parsedValue
          }));
        }
      }
    };
    $[16] = max;
    $[17] = min;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  const handleInputChange = t6;
  let t7;
  if ($[19] !== onChange || $[20] !== rangeValues.max || $[21] !== rangeValues.min || $[22] !== value) {
    t7 = e_0 => {
      if (!/\d/.test(e_0.key) && !["Backspace", "Tab", "Enter"].includes(e_0.key)) {
        e_0.preventDefault();
      }
      if (e_0.key === "Enter" && onChange) {
        onChange(value, rangeValues.min, rangeValues.max);
      }
    };
    $[19] = onChange;
    $[20] = rangeValues.max;
    $[21] = rangeValues.min;
    $[22] = value;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  const handleInputKeys = t7;
  let t8;
  if ($[24] !== formatMessage || $[25] !== keyExists || $[26] !== label || $[27] !== value) {
    t8 = keyExists(`ranges.${value}.min`) ? formatMessage(`ranges.${value}.min`, {
      label
    }) : formatMessage("ranges.default.min", {
      label
    });
    $[24] = formatMessage;
    $[25] = keyExists;
    $[26] = label;
    $[27] = value;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  let t9;
  if ($[29] !== t8) {
    t9 = <label htmlFor="min-range-input" className="sr-only">{t8}</label>;
    $[29] = t8;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  let t10;
  if ($[31] !== rangeValues.max) {
    t10 = event => {
      const value_3 = Math.min(Number(event.target.value), rangeValues.max - 1);
      setRangeValues(prevValues_1 => ({
        ...prevValues_1,
        min: value_3
      }));
      setInputValues(prev_1 => ({
        ...prev_1,
        min: value_3
      }));
    };
    $[31] = rangeValues.max;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  const t11 = rangeValues.min > max - 100 ? "5" : "3";
  let t12;
  if ($[33] !== t11) {
    t12 = {
      zIndex: t11
    };
    $[33] = t11;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  let t13;
  let t14;
  if ($[35] !== onChange || $[36] !== rangeValues.max || $[37] !== rangeValues.min || $[38] !== value) {
    t13 = () => onChange(value, rangeValues.min, rangeValues.max);
    t14 = () => onChange(value, rangeValues.min, rangeValues.max);
    $[35] = onChange;
    $[36] = rangeValues.max;
    $[37] = rangeValues.min;
    $[38] = value;
    $[39] = t13;
    $[40] = t14;
  } else {
    t13 = $[39];
    t14 = $[40];
  }
  const t15 = `${rangeValues.min}`;
  let t16;
  if ($[41] !== max || $[42] !== min || $[43] !== rangeValues.min || $[44] !== t10 || $[45] !== t12 || $[46] !== t13 || $[47] !== t14 || $[48] !== t15) {
    t16 = <input id="min-range-input" type="range" min={min} max={max} value={rangeValues.min} onChange={t10} className={styles.thumb} style={t12} onMouseUp={t13} onTouchEnd={t14} aria-valuemin={min} aria-valuemax={max} aria-valuenow={rangeValues.min} aria-valuetext={t15} />;
    $[41] = max;
    $[42] = min;
    $[43] = rangeValues.min;
    $[44] = t10;
    $[45] = t12;
    $[46] = t13;
    $[47] = t14;
    $[48] = t15;
    $[49] = t16;
  } else {
    t16 = $[49];
  }
  let t17;
  if ($[50] !== formatMessage || $[51] !== keyExists || $[52] !== label || $[53] !== value) {
    t17 = keyExists(`ranges.${value}.max`) ? formatMessage(`ranges.${value}.max`, {
      label
    }) : formatMessage("ranges.default.max", {
      label
    });
    $[50] = formatMessage;
    $[51] = keyExists;
    $[52] = label;
    $[53] = value;
    $[54] = t17;
  } else {
    t17 = $[54];
  }
  let t18;
  if ($[55] !== t17) {
    t18 = <label htmlFor="max-range-input" className="sr-only">{t17}</label>;
    $[55] = t17;
    $[56] = t18;
  } else {
    t18 = $[56];
  }
  let t19;
  if ($[57] !== rangeValues.min) {
    t19 = event_0 => {
      const value_4 = Math.max(Number(event_0.target.value), rangeValues.min + 1);
      setRangeValues(prevValues_2 => ({
        ...prevValues_2,
        max: value_4
      }));
      setInputValues(prev_2 => ({
        ...prev_2,
        max: value_4
      }));
    };
    $[57] = rangeValues.min;
    $[58] = t19;
  } else {
    t19 = $[58];
  }
  let t20;
  let t21;
  if ($[59] !== onChange || $[60] !== rangeValues.max || $[61] !== rangeValues.min || $[62] !== value) {
    t20 = () => onChange(value, rangeValues.min, rangeValues.max);
    t21 = () => onChange(value, rangeValues.min, rangeValues.max);
    $[59] = onChange;
    $[60] = rangeValues.max;
    $[61] = rangeValues.min;
    $[62] = value;
    $[63] = t20;
    $[64] = t21;
  } else {
    t20 = $[63];
    t21 = $[64];
  }
  const t22 = `${rangeValues.max}`;
  let t23;
  if ($[65] !== max || $[66] !== min || $[67] !== rangeValues.max || $[68] !== t19 || $[69] !== t20 || $[70] !== t21 || $[71] !== t22) {
    t23 = <input id="max-range-input" type="range" min={min} max={max} value={rangeValues.max} onChange={t19} className={`${styles.thumb} ${styles["thumb--right"]}`} onMouseUp={t20} onTouchEnd={t21} aria-valuemin={min} aria-valuemax={max} aria-valuenow={rangeValues.max} aria-valuetext={t22} />;
    $[65] = max;
    $[66] = min;
    $[67] = rangeValues.max;
    $[68] = t19;
    $[69] = t20;
    $[70] = t21;
    $[71] = t22;
    $[72] = t23;
  } else {
    t23 = $[72];
  }
  let t24;
  if ($[73] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <div className={styles.slider}><div className={styles.slider__track} /><div ref={range} className={styles.slider__range} /></div>;
    $[73] = t24;
  } else {
    t24 = $[73];
  }
  let t25;
  if ($[74] !== t16 || $[75] !== t18 || $[76] !== t23 || $[77] !== t9) {
    t25 = <div className={styles["slider-container"]}>{t9}{t16}{t18}{t23}{t24}</div>;
    $[74] = t16;
    $[75] = t18;
    $[76] = t23;
    $[77] = t9;
    $[78] = t25;
  } else {
    t25 = $[78];
  }
  let t26;
  if ($[79] !== formatMessage || $[80] !== keyExists || $[81] !== label || $[82] !== value) {
    t26 = keyExists(`ranges.${value}.min`) ? formatMessage(`ranges.${value}.min`, {
      label
    }) : formatMessage("ranges.default.min", {
      label
    });
    $[79] = formatMessage;
    $[80] = keyExists;
    $[81] = label;
    $[82] = value;
    $[83] = t26;
  } else {
    t26 = $[83];
  }
  let t27;
  if ($[84] !== t26) {
    t27 = <label htmlFor="min-input" className="sr-only">{t26}</label>;
    $[84] = t26;
    $[85] = t27;
  } else {
    t27 = $[85];
  }
  let t28;
  let t29;
  if ($[86] !== handleInputChange) {
    t28 = event_1 => handleInputChange(event_1, SelectorType.MIN);
    t29 = event_2 => handleInputChange(event_2, SelectorType.MIN);
    $[86] = handleInputChange;
    $[87] = t28;
    $[88] = t29;
  } else {
    t28 = $[87];
    t29 = $[88];
  }
  let t30;
  if ($[89] !== handleInputKeys || $[90] !== inputValues.min || $[91] !== t28 || $[92] !== t29) {
    t30 = <input id="min-input" type="text" className={styles.slider__input} inputMode="numeric" pattern="[0-9]*" onChange={t28} onBlur={t29} onKeyDown={handleInputKeys} value={inputValues.min} />;
    $[89] = handleInputKeys;
    $[90] = inputValues.min;
    $[91] = t28;
    $[92] = t29;
    $[93] = t30;
  } else {
    t30 = $[93];
  }
  let t31;
  if ($[94] !== quantitySymbol) {
    t31 = <span>{quantitySymbol}</span>;
    $[94] = quantitySymbol;
    $[95] = t31;
  } else {
    t31 = $[95];
  }
  let t32;
  if ($[96] !== t27 || $[97] !== t30 || $[98] !== t31) {
    t32 = <div className={styles["slider__input-wrapper"]}><div className={`${styles["slider__input-content"]} body-bold`}>{t27}{t30}{t31}</div></div>;
    $[96] = t27;
    $[97] = t30;
    $[98] = t31;
    $[99] = t32;
  } else {
    t32 = $[99];
  }
  let t33;
  if ($[100] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <span className={styles["slider__input-separator"]} />;
    $[100] = t33;
  } else {
    t33 = $[100];
  }
  let t34;
  if ($[101] !== formatMessage || $[102] !== keyExists || $[103] !== label || $[104] !== value) {
    t34 = keyExists(`ranges.${value}.max`) ? formatMessage(`ranges.${value}.max`, {
      label
    }) : formatMessage("ranges.default.max", {
      label
    });
    $[101] = formatMessage;
    $[102] = keyExists;
    $[103] = label;
    $[104] = value;
    $[105] = t34;
  } else {
    t34 = $[105];
  }
  let t35;
  if ($[106] !== t34) {
    t35 = <label htmlFor="max-input" className="sr-only">{t34}</label>;
    $[106] = t34;
    $[107] = t35;
  } else {
    t35 = $[107];
  }
  let t36;
  let t37;
  if ($[108] !== handleInputChange) {
    t36 = event_3 => handleInputChange(event_3, SelectorType.MAX);
    t37 = event_4 => handleInputChange(event_4, SelectorType.MAX);
    $[108] = handleInputChange;
    $[109] = t36;
    $[110] = t37;
  } else {
    t36 = $[109];
    t37 = $[110];
  }
  let t38;
  if ($[111] !== handleInputKeys || $[112] !== inputValues.max || $[113] !== t36 || $[114] !== t37) {
    t38 = <input id="max-input" type="text" className={styles.slider__input} inputMode="numeric" pattern="[0-9]*" onChange={t36} onBlur={t37} onKeyDown={handleInputKeys} value={inputValues.max} />;
    $[111] = handleInputKeys;
    $[112] = inputValues.max;
    $[113] = t36;
    $[114] = t37;
    $[115] = t38;
  } else {
    t38 = $[115];
  }
  let t39;
  if ($[116] !== quantitySymbol) {
    t39 = <span>{quantitySymbol}</span>;
    $[116] = quantitySymbol;
    $[117] = t39;
  } else {
    t39 = $[117];
  }
  let t40;
  if ($[118] !== t35 || $[119] !== t38 || $[120] !== t39) {
    t40 = <div className={styles["slider__input-wrapper"]}><div className={`${styles["slider__input-content"]} body-bold`}>{t35}{t38}{t39}</div></div>;
    $[118] = t35;
    $[119] = t38;
    $[120] = t39;
    $[121] = t40;
  } else {
    t40 = $[121];
  }
  let t41;
  if ($[122] !== t32 || $[123] !== t40) {
    t41 = <div className={styles.slider__values}>{t32}{t33}{t40}</div>;
    $[122] = t32;
    $[123] = t40;
    $[124] = t41;
  } else {
    t41 = $[124];
  }
  let t42;
  if ($[125] !== label || $[126] !== t25 || $[127] !== t41) {
    t42 = <div className={styles["multi-range-slider"]} title={label}>{t25}{t41}</div>;
    $[125] = label;
    $[126] = t25;
    $[127] = t41;
    $[128] = t42;
  } else {
    t42 = $[128];
  }
  return t42;
}
export default MultiRangeSliderComponent;